export default "__VITE_ASSET__O7mu_jv3__";